import { render, staticRenderFns } from "./ypDetail.vue?vue&type=template&id=25d62cff&scoped=true"
import script from "./ypDetail.vue?vue&type=script&lang=js"
export * from "./ypDetail.vue?vue&type=script&lang=js"
import style0 from "./ypDetail.vue?vue&type=style&index=0&id=25d62cff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d62cff",
  null
  
)

export default component.exports